import { Gutter } from 'antd/lib/grid/row';

export const STAGE_2 = {
  FERTILIZER_LABELS: {
    GUTTER_VALUE: [15, 25] as Gutter,
    INGREDIENT_NAME: 'Fertilizer name',
    INGREDIENT_ORIGIN: 'Fertilizer Origin',
    SUPPLIER: 'Supplier',
    TEMPERATURE_CONTROL: 'Temperature control',
    CHECK_TRANSPORTATION: 'Check this box if transportation is via air.',
  },
  PACKAGING_LABELS: {
    MATERIAL_NAME: 'Enter Packaging Material name/origin',
    MATERIAL_ORIGIN: 'Ingredient Origin',
  },
  TRANSPORTATION_FIELD_NAMES: {
    SUPPLIER_FIELD: 'supplierId',
    TEMPERATURE_CONTROL_FIELD: 'temperatureControl',
    IS_AIR_TRANSPORTED_FIELD: 'isTransportedByAir',
    NAME_FIELD: 'name',
    ORIGIN_FIELD: 'getFormattedAddress',
    FERTILIZER: 'fertilizers',
    PACKAGING: 'packagings',
  },
  HEADING: {
    FERTILIZER: 'Fertilizer/ Pesticide Inputs',
    PACKAGING: 'Packaging material',
  },
};

export enum TRANSPORTATION_FIELD_STAGE2 {
  FERTILIZER = 'fertilizers',
  PACKAGING = 'packagings',
}
